class DialogManager {

    dialogMappings = {
        '#gender-hint': '#gender-info-dialog',
        '#pro-hint': '#professional-info-dialog',
        '#product-note': '#product-note-dialog',
        '#welcome': '#welcome-dialog'
    };

    constructor() {
        this.initializeEventListeners();
    }

    // Zeigt einen Dialog an
    showDialog(triggerSelector) {
        const dialogSelector = this.dialogMappings[triggerSelector];
        if (dialogSelector) {
            $(dialogSelector).get(0).showModal();
        }
    }

    // Schließt einen Dialog
    closeDialog(triggerSelector) {
        const dialogSelector = this.dialogMappings[triggerSelector];
        if (dialogSelector) {
            $(dialogSelector).get(0).close();
        }
    }

    // Initialisiert Event Listeners
    initializeEventListeners() {
        Object.keys(this.dialogMappings).forEach(triggerSelector => {
            // Registrierung des Click-Events für den Trigger
            $(triggerSelector).on('click', (e) => {
                e.preventDefault();
                this.showDialog(triggerSelector);
            });

            // Registrierung des Click-Events für die Schließen-Schaltfläche
            const dialogSelector = this.dialogMappings[triggerSelector];
            if (dialogSelector) {
                $(`${dialogSelector} .close-dialog`).on('click', () => {
                    this.closeDialog(triggerSelector);
                });
            }
        });
    }
}